import React from 'react';
import style from './style.scss';
import logo from '../../assets/images/logo.svg';

export default () => (
  <img src={logo} className="logo"/>
);



// WEBPACK FOOTER //
// ./src/components/logo/index.js